export default __webpack_public_path__ + "static/media/ConstructionVector.bd67227e.svg";